<header class='ra-header'>
    <a href="https://www.allianz.com.tw/zh_TW.html" class="ra-logo" title='回首頁'></a>
</header>
<div class="ra-err-wrapper">
    <p class='ra-err-title'>系統異常，<br>請稍後再試！</p>
    <a href='{{ERROR_REPORT_URL}}' class="ra-btn ra-idx-btn ra-btn-txt-arrow-tail"><span class='txt-idx-btn-txt' style='margin:0 22px;'>錯誤回報</span></a>
</div>
<footer class='ra-footer'>
    <div class="ra-ft-in">
        <div class="ra-ft-copyright txt-ft-cp">©Allianz 2021. All Rights Reserved.</div>
        <div class="ra-ft-link">
            <a href="https://www.allianz.com.tw/zh_TW/statement.html" class='txt-ft-a ra-ft-announce' title='網站聲明' target="_blank">網站聲明</a>
            <!-- <a href="javascript:;" class='txt-ft-a ra-ft-cookies' title='Cookies政策' data-open="idModalCookies">Cookies政策</a> -->
            <a href="https://www.allianz.com.tw/zh_TW/about-us/contact-us/contact-us.html" class='txt-ft-a ra-ft-contact' title='聯絡我們' target="_blank">聯絡我們</a>
        </div>
    </div>
</footer>
